import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';

import SummaryDay from './SummaryDay';

const SummaryContent = ({
  mealTypes,
  dates,
  diets,
  classes,
  variant,
  menuPlanners,
  loading,
}) => {
  if (variant === '') {
    return null;
  }

  if (loading) {
    return null;
  }

  const filteredMealTypes = mealTypes
    ?.sort((a, b) => a.position - b.position)
    ?.filter(mealType => {
      // eslint-disable-next-line no-unsafe-optional-chaining -- FIXME
      const array = [...variant?.mealTypes];

      return array?.includes(mealType['@id']);
    });

  const byDay = {};

  menuPlanners?.forEach(mp => {
    if (!mp) {
      return;
    }

    const day = moment(mp.date).format('YYYY-MM-DD');

    if (!byDay[day]) {
      byDay[day] = [];
    }

    byDay[day].push(mp);
  });

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell
                padding="dense"
                style={{ borderBottom: 0 }}
                colSpan={1}
              />
              {filteredMealTypes.map((mealType, index) => (
                <TableCell
                  colSpan={1}
                  key={index}
                  align="center"
                  padding="dense"
                >
                  {mealType.name}
                </TableCell>
              ))}
            </TableRow>
            {dates.map(day => (
              <SummaryDay
                key={day}
                day={day}
                diets={diets}
                variant={variant}
                filteredMealTypes={filteredMealTypes}
                menuPlanners={byDay[day] || []}
              />
            ))}
          </TableHead>
        </Table>
      </GridItem>
    </GridContainer>
  );
};

const mapStateToProps = state => ({
  mealTypes: state.MealTypes.mealTypes,
});

const enhance = compose(
  connect(mapStateToProps, null),
  withStyles(buttonsStyle),
  withTranslation()
);

export default enhance(SummaryContent);
